import { render, staticRenderFns } from "./BijuleeNewsBulletin.vue?vue&type=template&id=49b76e40&scoped=true&"
import script from "./BijuleeNewsBulletin.vue?vue&type=script&lang=js&"
export * from "./BijuleeNewsBulletin.vue?vue&type=script&lang=js&"
import style0 from "./BijuleeNewsBulletin.vue?vue&type=style&index=0&id=49b76e40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b76e40",
  null
  
)

export default component.exports